/**
 * feedback.js — toasts and confirmation dialogs, in the new look, for the WHOLE app.
 *
 * The old app shows feedback through two Redux actions used by every screen:
 *   showAlert(text)                 → toast        (rendered by containers/displayHelpers/alertMsg)
 *   withConfirmAlert(callback,text) → yes/no box   (actions/generalActions.js)
 * Their call sites and behaviour stay the same; only the UI they render now comes
 * from here, so old and new screens alike get the new toasts/dialogs.
 *
 * Imported directly (not via ui/index.js) by actions/, to avoid an import cycle.
 */
import { message, Modal } from 'antd';

// Toast at the top of the screen. Same 4s lifetime the Redux alert used.
export const showToast = (text) => {
  if (!text) return;
  message.open({ type: 'info', content: text, duration: 4 });
};

// Yes/no confirmation. `onYes` runs only on confirm (same as the old "כן" button).
export const confirmAction = ({ text, onYes }) => {
  Modal.confirm({
    title: 'אישור פעולה',
    content: text || null,
    okText: 'כן',
    cancelText: 'לא',
    centered: true,
    autoFocusButton: 'cancel',
    onOk: () => {
      onYes();
    },
  });
};
